import { render } from "./ExternalButtonLink.vue?vue&type=template&id=a3c1566a&scoped=true"
import script from "./ExternalButtonLink.vue?vue&type=script&lang=js"
export * from "./ExternalButtonLink.vue?vue&type=script&lang=js"

import "./ExternalButtonLink.vue?vue&type=style&index=0&id=a3c1566a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c1566a"]])

export default __exports__